import { RouteConfig } from 'vue-router';

import { procedureCreateRoute } from './procedureRoute/create.route';
import { procedureDetailsRoute } from './procedureRoute/details.route';
import { proceduresRoute } from './procedureRoute/list.route';

export const procedureRoute: RouteConfig = {
  path: 'procedure',
  component: () => import(/* webpackChunkName: "ProcedureContainer" */ '@/views/mainRoute/procedure/Container.vue'),
  meta: {
    breadcrumb: { title: 'Lista procedur', name: 'procedureList' },
    menu: {
      title: 'Lista procedur',
      name: 'procedureList',
      icon: 'fa-list-ul',
      permissions: ['PROCEDURE.LIST']
    }
  },
  children: [proceduresRoute, procedureCreateRoute, procedureDetailsRoute]
};
